export enum QueryKey {
  Home = 'home',
  Tree = 'tree',
  TreePath = 'treePath',
  Asset = 'asset',
  AssetData = 'assetData',
  MultipleAssets = 'multipleAssets',
  VariantUrls = 'variantUrls',
  Folder = 'folder',
  Album = 'album',
  Tag = 'tag',
  Tags = 'tags',
  TagList = 'tagList',
  Destination = 'destination',
  DestinationList = 'destinationList',
  Metadata = 'metadata',
  MetadataList = 'metadataList',
  Share = 'share',
  GetShare = 'getShare',
  NodeShareList = 'nodeShareList',
  ShareList = 'shareList',
  TreeSearch = 'treeSearch',
  InvitationList = 'invitationList',
  NotificationList = 'notificationList',
  Variant = 'variant',
  VariantList = 'variantList',
  Workflow = 'workflow',
  WorkflowList = 'workflowList',
  User = 'user',
  UserList = 'userList',
  NotesList = 'notesList',
  NodeCommentList = 'nodeCommentList',
  Profile = 'profile',
  TermsLatest = 'termsLatest',
  Trash = 'trash',
  SearchFacets = 'searchFacets',
  AuditData = 'auditData',
  Duplicates = 'duplicates',
  Export = 'export',
  ShareExport = 'shareExport',
  NodeLinkList = 'nodeLinkList',
  ResolvedLink = 'resolvedLink',
}

export const buildTreeQueryKey = (nodeId: string) => [QueryKey.Tree, { nodeId }] as const;

export const buildTreePathQueryKey = (pathArray: Array<string>) => [QueryKey.TreePath, pathArray.join('/')] as const;
